$(document).ready(function () {

  var addDays = (date, days = 1) => {
    var result = new Date(date);  
    //console.log('result',result); 
    result.setDate(result.getDate() + days);
    return result;
  };

var dateRange = (start, end, range = []) => {
 // console.log(start+"===="+end);
  if (start > end){ return range; }
  var next = addDays(start, 1);
  var rangVal = dateRange(next, end, [...range, start]);
  return rangVal;
};


var startdate = $('.start-date-main').attr('date');
var enddate = $('.end-date-main').attr("date");
var buffer_date = $('.buffer_date_add').attr("buffer-date");


var range = dateRange(new Date(startdate), new Date(enddate));

  var maindate = range.map((date) => {
    var mm = (date.getMonth() + 1).toString();
    var dd = date.getDate().toString();
    var yy = date.getFullYear().toString();
    return `${mm}/${dd}/${yy}`;
  });


  
   var unavailableDates = maindate;

    function unavailable(date) {
        dmy = (date.getMonth() + 1) + "/" +date.getDate() + "/" +   date.getFullYear();
        if ($.inArray(dmy, unavailableDates) == -1) {
            return [true, ""];
        } else {
            return [false, "", "Unavailable"];
        }
    }
      
    $(function() {
      
   var daycount = $("input[name='Rental Duration']:checked").val();
      if(daycount == undefined){
        var number = 0;
      } else{
       var number = parseInt(daycount.split(" ")[0]) -1 ;
      }
    // Compact mode drives the date with a native <input type="date">; skip
    // binding jQuery UI to the (now hidden) carrier so the two never contend.
    if (!document.getElementById('gl-arrival')) {
      datepickerCustom(number)
    }


    });

 $('body').on('click','fieldset.js.product-form__input.variant-input-wrapper[data-option-slug="rental-duration"] label',function () {
        var getText =   $(this).prev('input').val();
      var number = parseInt(getText.split(" ")[0]) -1;
 
     $("#datepicker-delivery").datepicker( "destroy" );
     $("#datepicker-delivery").val(''); 
       datepickerCustom(number)
   
        });

function datepickerCustom(number){
    var startDate = null;
      $("#datepicker-delivery").datepicker({
            dateFormat: 'mm/dd/yy',
            minDate: buffer_date ,
              maxDate: (function() {
                const today = new Date();
                return new Date(today.getFullYear(), today.getMonth() + 6, 0);
            })(),
            beforeShowDay: function(date) {
            if (startDate && date >= startDate && date <= endDate) {
                return [true, 'highlight-range', '']; 
            }
           
            return [true, '', ''];
        },
         onSelect: function(selectedDate) {
            startDate = new Date(selectedDate);
            endDate = new Date(selectedDate);
            endDate.setDate(endDate.getDate() + number);
           if(number == 0){
             $("#datepicker-delivery").val(selectedDate);
           } else{
            $("#datepicker-delivery").val(selectedDate + ' - ' + $.datepicker.formatDate('mm/dd/yy', endDate));
           }
            /* BUGFIX 2026-07-26 — jQuery UI sets .val() directly here, which
               fires NO change event. That is why the old re-enable handler
               (`$("#datepicker-delivery").change(...)`) never ran and the Add
               to Cart button stayed dead after picking a date. Everything that
               reacts to "a date now exists" — the validation message and the
               express-checkout gate — hangs off this event, so fire it. */
            $("#datepicker-delivery").trigger("change");
        }
        
        });
}  

  

  var $cstmval = jQuery(".element-classname").val();

  /* ------------------------------------------------------------------
     Required "preferred arrival date" gate on Add to Cart.

     BUGFIX 2026-07-26 — this used to DISABLE the button when the date was
     empty. A disabled button fires no further click events, so the re-enable
     branch below it could never run. The only other re-enable path was a
     `change` handler on the datepicker, which (a) undid an .attr() with a
     .prop() and (b) depends on jQuery UI actually emitting `change` on select.
     Reproduced on live: tap Add to Cart BEFORE picking a date -> button greys
     out permanently, and picking a date afterwards does NOT recover it. Only a
     full page reload does. Tapping the biggest button first is exactly what a
     scrolling mobile shopper does, and mobile converts at half the desktop
     rate.

     Fix: never disable the button. Block the submit instead, and let the
     shopper retry as soon as they have picked a date. The button cannot get
     stuck because it is never put into a state it can't leave.
     ------------------------------------------------------------------ */
  jQuery(".product-form__submit").on("click", function (e) {
    var empty = false;
    jQuery("#datepicker-delivery").each(function () {
      if (jQuery.trim(jQuery(this).val()) === "") {
        empty = true;
      }
    });

    if (empty) {
      e.preventDefault();
      e.stopImmediatePropagation();          // keep the theme's own submit from running
      jQuery(".validation-message-jtpl").show();
      /* Bring the field into view before focusing it. The blocked click often
         comes from the STICKY bar, and by then the datepicker can be a
         thousand pixels up the page — the shopper sees a button that did
         nothing and an error message they never scrolled to. */
      glRevealDateField();
      var focusEl = document.getElementById("gl-arrival") || document.getElementById("datepicker-delivery");
      if (focusEl) { jQuery(focusEl).trigger("focus"); }
      return false;
    }
    jQuery(".validation-message-jtpl").hide();
  });

  /* Scroll the arrival-date field into view. Guarded because the field only
     exists on templates whose product opts into it. */
  function glRevealDateField() {
    /* Prefer the VISIBLE native field where it exists (compact mode); the
       carrier #datepicker-delivery is hidden there and cannot be scrolled to
       or focused meaningfully. */
    var el = document.getElementById("gl-arrival") || document.getElementById("datepicker-delivery");
    if (!el) { return; }
    /* window.scrollTo, not scrollIntoView — the theme's body scroll container
       makes scrollIntoView a verified no-op on this site, so this reveal was
       silently doing nothing for exactly the shopper it exists for: someone
       who tapped the sticky Add to Cart a thousand pixels below the field. */
    var top = Math.max(
      0,
      el.getBoundingClientRect().top + window.pageYOffset - (window.innerHeight / 2)
    );
    window.scrollTo({ top: top, behavior: "smooth" });
  }

  /* Clear the warning as soon as a date exists, however it was entered:
     jQuery UI's onSelect, a paste, or typing. Also defensively strips any
     leftover disabled attribute from a pre-fix page state. */
  function glClearDateWarning() {
    if (jQuery.trim(jQuery("#datepicker-delivery").val()) !== "") {
      jQuery(".validation-message-jtpl").hide();
      jQuery(".product-form__submit").removeAttr("disabled").prop("disabled", false);
    }
  }

  /* ------------------------------------------------------------------
     EXPRESS CHECKOUT GATE (2026-07-26)

     Shop Pay / Apple Pay / Google Pay are now enabled on the product
     templates. Those buttons submit the form DIRECTLY — they never fire the
     `.product-form__submit` click handler above, so without this gate an
     express order could be placed with NO arrival date, and the lab would not
     know when to ship a wedding order.

     The gate is CSS-driven (pointer-events + opacity on the wrapper) rather
     than `disabled`, deliberately: the wallet buttons are third-party and
     partly iframed, and a `disabled` attribute is exactly what created the
     stuck-button bug this file just fixed. A CSS gate has no state to get
     stuck in — it re-evaluates from the field's current value every time.
     ------------------------------------------------------------------ */
  function glSyncExpressGate() {
    var $d = jQuery("#datepicker-delivery");
    if (!$d.length) { return; }              // template has no date field -> no gate
    var empty = jQuery.trim($d.val()) === "";
    jQuery(".product-form__buttons").toggleClass("gl-date-required", empty);
  }

  /* ------------------------------------------------------------------
     EXPRESS GATE — FUNCTIONAL BACKSTOP (2026-07-26)

     The CSS gate above is `pointer-events: none`, which stops a MOUSE. It does
     not stop the keyboard: Tab to the Shop Pay button, press Enter, and the
     wallet opens with no arrival date. It also does not stop a synthetic
     click. The CSS is the visual affordance; this is the actual rule.

     Bound at the DOCUMENT in the CAPTURE phase because Shopify's
     accelerated-checkout buttons live in shadow DOM and web components —
     events are retargeted, so a listener on the button itself may never see
     them, and a bubble-phase listener runs after the wallet has already acted.

     Emptiness is read AT the moment of interaction. There is no stored state
     and nothing to re-enable, so this cannot reintroduce the stuck-button bug
     that the `disabled` attribute caused.
     ------------------------------------------------------------------ */
  function glExpressGuard(e) {
    var inWallet = e.target && e.target.closest && e.target.closest(".shopify-payment-button");
    if (!inWallet) { return; }
    var $d = jQuery("#datepicker-delivery");
    if (!$d.length || jQuery.trim($d.val()) !== "") { return; }  // no field, or date set: allow
    e.preventDefault();
    e.stopPropagation();
    jQuery(".validation-message-jtpl").show();
    glRevealDateField();
  }
  document.addEventListener("click", glExpressGuard, true);
  document.addEventListener("keydown", function (e) {
    if (e.key === "Enter" || e.key === " ") { glExpressGuard(e); }
  }, true);

  /* One hint line under the wallet buttons, injected once.
     SCOPED to the MAIN buy form (product-form.product-form). Unscoped, this
     also appended to the sticky bar's .product-form__buttons — the sticky bar
     has no wallet buttons to explain, and the extra line bloated it to ~188px
     tall on a 375px screen, eating a quarter of the viewport. */
  jQuery("product-form.product-form .product-form__buttons").each(function () {
    var $b = jQuery(this);
    if (jQuery("#datepicker-delivery").length && !$b.find(".gl-express-hint").length) {
      $b.append('<span class="gl-express-hint">Choose your preferred arrival date above to check out with Shop Pay, Apple Pay or Google Pay.</span>');
    }
  });

  /* ------------------------------------------------------------------
     STICKY-CART DATE CARRY (hotfix 2026-07-26)

     The sticky Add-to-Cart bar renders its OWN /cart/add form. The datepicker
     (#datepicker-delivery, properties[Event Date]) belongs to the main buy
     form only, so the sticky form carried no event date and a shopper who
     picked a date then used the sticky button added a line item WITHOUT it —
     the lab never learned the ship-by date. Silent; it only surfaces weeks
     later as a late delivery.

     The empty-date click gate above already covers the no-date case (the
     sticky button is also .product-form__submit). This is purely about
     carrying the value once a date exists.

     The input itself is now SERVER-RENDERED in sections/main-product.liquid
     (.gl-sticky-event-date, gated on the same metafield as the date field), so
     it exists even if scripts are slow or blocked. This only keeps it in sync.
     ------------------------------------------------------------------ */
  function glSyncStickyDate() {
    jQuery(".gl-sticky-event-date").val(jQuery("#datepicker-delivery").val() || "");
  }

  /* Occasion -> sticky bar. Identical reasoning to the date above: the sticky
     bar is a SECOND /cart/add form, so anything the main form collects has to
     be mirrored into it or a sticky-button order arrives without it. Here that
     would mean the occasion data silently going missing on exactly the orders
     placed from the sticky bar — a biased hole in the dataset rather than an
     obvious empty one, which is worse than collecting nothing. */
  function glSyncStickyOccasion() {
    var checked = document.querySelector(
      '[data-gl-occasion] input[name="properties[Occasion]"]:checked'
    );
    jQuery(".gl-sticky-occasion").val(checked ? checked.value : "");
  }

  jQuery(document).on(
    "change",
    '[data-gl-occasion] input[name="properties[Occasion]"]',
    glSyncStickyOccasion
  );
  glSyncStickyOccasion();

  jQuery("#datepicker-delivery").on("change input blur", function () {
    glClearDateWarning();
    glSyncExpressGate();
    glSyncStickyDate();
  });

  glSyncExpressGate();                        // set the initial state on load
  glSyncStickyDate();

  /* ------------------------------------------------------------------
     NATIVE ARRIVAL DATE (2026-07-28)

     The jQuery UI picker opens via .datepicker('show') / .focus() but a real
     click on the field steals focus to #MainContent and closes it instantly —
     confirmed on desktop Chrome, not a preview artifact. It is the one field
     an order cannot complete without, so compact mode renders a native
     <input type="date"> (#gl-arrival) instead and keeps #datepicker-delivery
     as the hidden VALUE CARRIER (mm/dd/yyyy, name=properties[Event Date]) that
     the gate, sticky mirror, order card and validation already read.

     This bridge is the ONLY new wiring: native change -> reformat to
     mm/dd/yyyy -> write the carrier -> trigger its change, so every existing
     consumer behaves exactly as it did with the jQuery picker.
     ------------------------------------------------------------------ */
  var glNative = document.getElementById("gl-arrival");
  if (glNative) {
    /* Mirror the jQuery picker's window: minDate was `buffer_date` (a
       days-from-today count under the "buffer" naming) and maxDate the end of
       the current month +6. Compute both as yyyy-mm-dd for the native min/max.
       Falls back to today / +6mo if the buffer element is absent. */
    var pad2 = function (n) { return (n < 10 ? "0" : "") + n; };
    var iso = function (d) {
      return d.getFullYear() + "-" + pad2(d.getMonth() + 1) + "-" + pad2(d.getDate());
    };
    var today = new Date();
    var minD = new Date(today);
    var bufRaw = jQuery(".buffer_date_add").attr("buffer-date");
    if (bufRaw != null && /^\d+$/.test(String(bufRaw).trim())) {
      minD.setDate(minD.getDate() + parseInt(bufRaw, 10));
    } else if (bufRaw) {
      var parsed = new Date(bufRaw);
      if (!isNaN(parsed.getTime())) { minD = parsed; }
    }
    var maxD = new Date(today.getFullYear(), today.getMonth() + 6, 0);
    glNative.min = iso(minD);
    glNative.max = iso(maxD);

    glNative.addEventListener("change", function () {
      var v = glNative.value;                  // yyyy-mm-dd, or "" if cleared
      var carrier = document.getElementById("datepicker-delivery");
      if (!carrier) { return; }
      /* Enforce the min/max window in JS. iOS and Android native date pickers do
         NOT prevent spinning to a day before `min` — they accept it and merely
         flag the field :invalid, which a presence-only gate would happily pass.
         So a mobile shopper could pick an arrival date inside the 11-day ship
         buffer. Clamp the value to [min, max]; ISO yyyy-mm-dd strings compare
         chronologically, so a lexical compare is correct here. */
      var glClamped = false;
      if (/^\d{4}-\d{2}-\d{2}$/.test(v)) {
        if (glNative.min && v < glNative.min) { v = glNative.min; glClamped = true; }
        else if (glNative.max && v > glNative.max) { v = glNative.max; glClamped = true; }
        if (glClamped) { glNative.value = v; }
      }
      /* Surface the clamp instead of silently moving the date: a calm inline
         notice appears only when we actually snapped the pick, and hides again on
         any in-window date or when the field is cleared. */
      var glDateNote = document.querySelector("[data-gl-date-note]");
      if (glDateNote) { glDateNote.hidden = !glClamped; }
      if (/^\d{4}-\d{2}-\d{2}$/.test(v)) {
        var p = v.split("-");                   // [yyyy, mm, dd]
        carrier.value = p[1] + "/" + p[2] + "/" + p[0];   // mm/dd/yyyy — the
                                                          // format the lab reads
      } else {
        /* Empty, or a text-fallback value on a browser without type=date
           support (effectively none in 2026). Pass it through rather than
           split a non-ISO string into a garbage date; the gate then simply
           treats an unparseable entry as no date, which is the safe default. */
        carrier.value = v || "";
      }
      /* FOMO: once a date is chosen, name the shopper's month so the urgency
         reads as specific to them ("June dates fill up fast…") rather than
         generic. Honest — popular wedding months genuinely book out and lab
         capacity is finite — so no fabricated live counter. Reverts to the
         default line if the field is cleared. */
      var fomoText = document.querySelector(".gl-date-fomo__text");
      if (fomoText) {
        var fomoBox = fomoText.closest(".gl-date-fomo");
        if (/^\d{4}-\d{2}-\d{2}$/.test(v)) {
          var GL_MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];
          var moName = GL_MONTHS[parseInt(v.split("-")[1], 10) - 1];
          if (moName) {
            fomoText.textContent = moName + " dates fill up fast — reserve yours soon to secure your spot.";
            if (fomoBox) { fomoBox.classList.add("is-active"); }
          }
        } else if (fomoBox) {
          fomoText.textContent = fomoBox.getAttribute("data-gl-fomo-default") || fomoText.textContent;
          fomoBox.classList.remove("is-active");
        }
      }

      /* Fire the same event the jQuery onSelect fired, so the gate release,
         the sticky mirror and the order-card mirror all run unchanged. Native
         dispatch reaches jQuery's .on('change') AND plain addEventListeners —
         which is strictly better than the jQuery-only trigger the picker used,
         and lets the order card drop its 700ms poll. */
      jQuery(carrier).trigger("change");
      carrier.dispatchEvent(new Event("change", { bubbles: true }));
    });

    /* "Need it sooner?" — the rush modal. Native <dialog> gives the backdrop,
       ESC-to-close and focus trap for free; we add a click-outside close and a
       graceful no-op if <dialog> is somehow unavailable. */
    var glRushOpen = document.querySelector("[data-gl-rush-open]");
    var glRushModal = document.querySelector("[data-gl-rush-modal]");
    if (glRushOpen && glRushModal && typeof glRushModal.showModal === "function") {
      glRushOpen.addEventListener("click", function () { glRushModal.showModal(); });
      var glRushClose = glRushModal.querySelector("[data-gl-rush-close]");
      if (glRushClose) {
        glRushClose.addEventListener("click", function () { glRushModal.close(); });
      }
      glRushModal.addEventListener("click", function (e) {
        /* Clicks on the ::backdrop report the dialog itself as target. */
        if (e.target === glRushModal) { glRushModal.close(); }
      });
    }

    /* WHOLE FIELD OPENS THE PICKER — except on the date digits (2026-07-28).
       Native date inputs only open on the calendar icon; the rest of the field
       does nothing. showPicker() opens it from anywhere, but we suppress that
       when the click lands on the mm/dd/yyyy text so a shopper can still click
       a segment to type. The shadow parts can't be hit-tested, so the text
       region is measured: the field's own text, rendered in its own font on a
       canvas, gives the right edge of the digits; clicks past it open the
       picker. No showPicker support (essentially no 2026 browser) falls back
       to the native icon, which still works. */
    if (typeof glNative.showPicker === "function") {
      var measureCanvas = document.createElement("canvas");
      var textRegionRight = function () {
        var cs = window.getComputedStyle(glNative);
        var padL = parseFloat(cs.paddingLeft) || 0;
        var shown = glNative.value
          ? glNative.value.split("-").reverse().join("/")  // rough width proxy
          : "mm/dd/yyyy";
        var ctx = measureCanvas.getContext("2d");
        ctx.font = cs.fontWeight + " " + cs.fontSize + " " + cs.fontFamily;
        return padL + ctx.measureText(shown).width + 10;
      };

      glNative.addEventListener("click", function (e) {
        var x = e.clientX - glNative.getBoundingClientRect().left;
        if (x <= textRegionRight()) { return; }   // on the digits -> let them type
        try { glNative.showPicker(); } catch (err) { /* already open / blocked */ }
      });
    }
  }

  /* ------------------------------------------------------------------
     IN-PAGE ANCHOR SCROLL (2026-07-27)

     Native fragment navigation does not move this theme's page — clicking
     an <a href="#buy"> leaves window.scrollY untouched, the same
     body{overflow:hidden auto} scroll-container quirk that made
     scrollIntoView a silent no-op for the package-picker CTAs. Every
     in-page CTA relies on these jumps (masthead -> #packages, the
     objections strip -> #buy/#reviews, the review wall and the seal ->
     #packages), so one delegated handler fixes them all: find the target,
     honour its scroll-margin-top, window.scrollTo — the one primitive
     verified to work here — and keep the hash in the URL without
     triggering the broken native jump.
     ------------------------------------------------------------------ */
  document.addEventListener("click", function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (!a) { return; }
    var id = a.getAttribute("href").slice(1);
    if (!id) { return; }                       // bare "#" -> not a jump
    var target = document.getElementById(id);
    if (!target) { return; }
    if (e.defaultPrevented) { return; }        // someone else owns this click
    e.preventDefault();
    var off = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
    var top = Math.max(0, target.getBoundingClientRect().top + window.pageYOffset - off);
    /* Always smooth (Ben). Plain anchor links don't dispatch a variant
       re-render, so nothing cancels the animation mid-flight the way it did
       for the package-picker CTA — that one keeps its own instant-for-far
       handling in package-picker.liquid. */
    window.scrollTo({ top: top, behavior: "smooth" });
    if (window.history && history.replaceState) {
      history.replaceState(null, "", "#" + id);
    }
  });

});





